import { User } from 'firebase/auth'
import { collection, CollectionReference, doc } from 'firebase/firestore'
import * as dt from 'modules/database/types'
import { db } from '.'

export function projectsCollection(user: User) {
	return collection(db, 'users', user.uid, 'projects') as CollectionReference<dt.Project>
}

export function projectReference(user: User, projectId: dt.ProjectID) {
	return doc(projectsCollection(user), projectId)
}

export function productsCollection(user: User, projectId: dt.ProjectID) {
	return collection(projectReference(user, projectId), 'products') as CollectionReference<dt.Product>
}

export function productReference(user: User, projectId: dt.ProjectID, productId: dt.ProductID) {
	return doc(productsCollection(user, projectId), productId)
}
